// extracted by mini-css-extract-plugin
export default {"light":"styles_light__SGtET","wrapperCard":"styles_wrapperCard__xIktz","nft":"styles_nft__9Hchl"};